import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography, Dialog, DialogActions, DialogContent, DialogTitle, Switch,Snackbar,Alert } from "@mui/material";
import axios from "axios";
import Header from "components/Header";
import { DataGrid } from "@mui/x-data-grid";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
const Slider = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  
  
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [imagePath, setImagePath] = useState("");
  const [imageMobilePath, setImageMobilePath] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [currentService, setCurrentService] = useState(null);
  const [title, setTitle] = useState("");
  const [titleMobile, setTitleMobile] = useState("");
  const [descriptionMobile, setDescriptionMobile] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  
  useEffect(() => {
    fetchData(); 
  }, []);    

  const fetchData = async () => {
    try {
      const response = await axios.get(`${apiUrl}/slider/getslider`);  
      setData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  const handleOpenModal = (service) => {
    if (service) {
      setCurrentService(service);
      setTitle(service.title);
      setDescription(service.description);
      setImagePath(service.image);
      setImageMobilePath(service.imageMobile || "");
    } else {
      setCurrentService(null);
      setTitle("");
      setDescription("");
      setImagePath("");
      setImageMobilePath("");
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setCurrentService(null);
  };
  
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const handleFileChangeProcess = (event) => {
    const selectedImage = event.target.files[0];
    if (selectedImage) {
      handleImageUpload(selectedImage, setImagePath); // Automatically upload the image
    }
  };
   const handleFileChangeProcessMobile = (event) => {
    const selectedImage = event.target.files[0];
    if (selectedImage) {
      handleImageUpload(selectedImage, setImageMobilePath);
    }
  };
  const handleImageUpload = async (file, setImagePath) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await axios.post(`${apiUrl}/upload`, formData);
      console.log("this is image path>>:", response.data.filePath);
      // setImagePath(response.data.filePath); // Assuming the backend returns the image path
      setImagePath(response.data.url);
    } catch (error) {
      console.error("Error uploading image:", error);
      setErrorMessage("Error uploading image.");
      setSnackbarOpen(true);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!title || !description|!imagePath) {
      setErrorMessage("Title,number and image are required.");
      setSnackbarOpen(true);
      return;
    }
    const postData = {
      title,
      description,
      image: imagePath,
      imageMobile: imageMobilePath,
    };

    try {
      const response = await axios.post(`${apiUrl}/slider/createslider`, postData);
      setData((prevData) => [...prevData, response.data]);
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    if (!title || !description|!imagePath) {
      setErrorMessage("Title,number and image are required.");
      setSnackbarOpen(true);
      return;
    }
    const updateData = {
      title,
      description,
      image: imagePath,
      imageMobile: imageMobilePath,
    };

    try {
      const response = await axios.put(`${apiUrl}/slider/updateslider/${currentService._id}`, updateData);
      setData((prevData) =>
        prevData.map((item) => (item._id === currentService._id ? response.data : item))
      );
      handleCloseModal();
    } catch (error) {
      console.error("Error updating service:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${apiUrl}/slider/deleteslider/${id}`);
      setData((prevData) => prevData.filter((item) => item._id !== id));
    } catch (error) {
      console.error("Error deleting service:", error);
    }
  };

  const handleToggleShow = async (id, currentValue) => {
    try {
      const response = await axios.put(`${apiUrl}/slider/updateshow/${id}`, {
        show: !currentValue,
      });
      // Update the local state to reflect the change
      setData((prevData) =>
        prevData.map((item) => (item._id === id ? { ...item, show: !currentValue } : item))
      );
    } catch (error) {
      console.error("Error toggling show:", error);
    }
  };

  const columns = [
    
    { field: "title", headerName: "Title", flex: 0.5 },
    { field: "description", headerName: "Description", flex: 0.5 },
    { field: "image", headerName: "Image", flex: 0.5, renderCell: (params) => (
      
      <img src={params.row.image} alt={params.row.title} width="50" height="50" />
    )},
    {
      field: "imageMobile",
      headerName: "Mobile Image",
      flex: 0.5,
      renderCell: (params) => (
        <img src={params.row.imageMobile} alt="mobile" width="50" height="50" />
      ),
    },
    {
      field: "show",
      headerName: "Show",
      flex: 0.5,
      renderCell: (params) => (
        <Switch
        checked={params.value}
        onChange={() => handleToggleShow(params.row._id, params.value)}
        />
      ),
      
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      renderCell: (params) => (
        <>
          <Button variant="contained"  style={{marginRight: 8}} color="primary" size="small" onClick={() => handleOpenModal(params.row)}>
            Update
          </Button>
          <Button variant="contained" color="secondary" size="small" onClick={() => handleDelete(params.row._id)}>
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="SLIDER" subtitle="List of Slider" />
      <Button variant="contained" color="primary" onClick={() => handleOpenModal(null)}>
        Add New Slider
      </Button>

      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>{currentService ? "Update Slider" : "Add New Slider"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Title"
            type="text"
            fullWidth
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Description"
            type="text"
            fullWidth
            variant="outlined"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <Button
            variant="outlined"
            component="label"
            startIcon={<CloudUploadIcon />}
          >
            Upload Image
            <input
              type="file"
              hidden
              onChange={handleFileChangeProcess} // Store the file object instead
            />
          </Button>
          {imagePath && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              <img src={imagePath} alt="image" width="50" height="50" />
            </Typography>
          )}
         <DialogTitle>{currentService ? "Update Mobile Slider" :"Add New Mobile Slider"}</DialogTitle>
         <Button variant="outlined" 
           component="label" 
           startIcon={<CloudUploadIcon />} 
           sx={{ mt: 1 }}>
            Upload Mobile Image
            <input type="file" 
            hidden onChange=
            {handleFileChangeProcessMobile} />
          </Button>
             {imageMobilePath && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              <img src={imageMobilePath} alt="mobile" width="50" height="50" />
            </Typography>
          )}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Cancel
          </Button>
          <Button onClick={currentService ? handleUpdate : handleSubmit} color="primary">
            {currentService ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Box mt="40px" height="75vh">
        <DataGrid
          loading={isLoading}
          getRowId={(row) => row._id}
          rows={data || []}
          columns={columns}
          pageSize={5}
        />
      </Box>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Slider;
